import api from './api';
import { FactorReajuste } from '@/types';

export const adjustmentService = {
  // Basic CRUD for adjustment factors
  getAdjustmentFactors: (filters?: any) => api.get('/adjustment-factors', { params: filters }),
  getAdjustmentFactorById: (id: number) => api.get(`/adjustment-factors/${id}`),
  createAdjustmentFactor: (data: Partial<FactorReajuste>) => api.post('/adjustment-factors', data),
  updateAdjustmentFactor: (id: number, data: Partial<FactorReajuste>) => api.put(`/adjustment-factors/${id}`, data),
  deleteAdjustmentFactor: (id: number) => api.delete(`/adjustment-factors/${id}`),

  // Adjustment application operations
  getContractsForAdjustment: (year: number, month: number) =>
    api.get(`/reajustes/${year}/${month}/contracts`),

  applyAdjustmentFactor: (year: number, month: number) =>
    api.post(`/reajustes/${year}/${month}/apply`),

  revertAdjustment: (factorId: number) =>
    api.post(`/reajustes/${factorId}/revert`),

  // Adjustment history and summary
  getAdjustmentHistory: (contratoId: number) =>
    api.get(`/contratos/${contratoId}/adjustments`),

  getAdjustmentSummary: (year?: number) =>
    api.get('/reajustes/summary', { params: year ? { year } : {} }),

  getAllReajustes: () => api.get('/reajustes'),
};

export default adjustmentService;
